import React, { useState } from 'react'
import { TableCell, TableRow } from '@mui/material'
import Column from './TableColumn';

const TableColumns = (props) => {
    const { columns, renders, config } = props
    const { actions, columnType = "static", getGroupedHeaders } = config
    const [_, forceUpdate] = useState({});
    const render = () => forceUpdate({})

    renders.allColumns = render

    const actionColumn = {
        name: "Action",
        value: "action",
    }

    if (columnType === "dynamic") {
        return (
            getGroupedHeaders(columns).map((level, rowIdx) => (
                <TableRow key={`header-row-${rowIdx}`}>
                    {level.map((cell, cellIdx) => (
                        <TableCell
                            key={`header-cell-${rowIdx}-${cellIdx}`}
                            align="center"
                            colSpan={cell.colSpan > 1 ? cell.colSpan : undefined}
                            rowSpan={cell.rowSpan > 1 ? cell.rowSpan : undefined}
                            sx={{ fontWeight: 'bold', bgcolor: '#f5f5f5' }}
                        >
                            {cell.label}
                        </TableCell>
                    ))}
                </TableRow>
            ))
        )
    }
    else if (columnType === "static") {
        return (
            <TableRow>
                {
                    Array.isArray(columns) && columns?.map((column, index) => {
                        return (
                            <TableCell
                                key={`column-${index}`}
                                sx={{ textTransform: 'none', textAlign: 'center', ...(!!column?.sx ? column?.sx : {}) }}
                                colSpan={column?.sx?.colSpan ? column.sx.colSpan : 1}
                            >
                                <Column
                                    column={column}
                                    renders={renders?.columns?.[index]}
                                    config={config}
                                />
                            </TableCell>
                        )
                    })
                }
                {
                    actions !== false
                        ? (
                            <TableCell sx={{ textTransform: 'none', textAlign: 'center' }}>
                                <Column
                                    column={actionColumn}
                                    renders={renders?.columns?.[columns?.length]}
                                    config={config}
                                />
                            </TableCell>
                        ) : null
                }
            </TableRow>
        )
    }
}

export default TableColumns
